<script setup>
  import { RouterLink, useRoute } from 'vue-router';

  const route = useRoute();

  defineProps({
    links: {
      type: Array,
      required: true,
    },
    disableLinks: {
      type: Boolean,
      default: false,
    },
  });

  function isAlbumsActive(link) {
    return link.highlight && link.highlight === route.meta.highlight;
  }
</script>

<template>
  <ul class="tw-flex tw-flex-col tw-space-y-1">
    <li class="tw-flex tw-w-full tw-items-center tw-rounded-lg tw-p-2 tw-pl-0 tw-pt-0" v-for="(link, index) in links" :key="index">
      <RouterLink
        :to="link.to"
        class="tw-group tw-w-full tw-rounded-md tw-p-1 hover:tw-bg-[#eaecf4]"
        :class="{ 'router-link-active router-link-exact-active': isAlbumsActive(link) }"
        :active-class="link.text === 'Home' ? '' : 'router-link-active'"
        :exact-active-class="link.text === 'Home' ? 'router-link-active router-link-exact-active' : 'router-link-exact-active'"
        @click="link?.action ? link.action() : ''"
      >
        <div class="tw-flex tw-h-8 tw-w-full tw-flex-row tw-items-center tw-justify-between">
          <div class="tw-flex tw-items-center tw-p-1">
            <v-icon class="tw-mr-4 tw-h-5 tw-w-5 group-[.active]:tw-text-[#4051a1] group-[.router-link-exact-active]:tw-text-[#4051a1]">
              {{ link.icon }}
            </v-icon>

            <span
              class="link-text tw-text-[0.850rem] tw-text-primary-black group-[.router-link-exact-active]:tw-font-semibold group-[.active]:tw-text-[#4051a1] group-[.router-link-exact-active]:tw-text-[#4051a1]"
            >
              {{ link.text }}
            </span>
          </div>
        </div>
      </RouterLink>
    </li>
  </ul>
</template>

<style scoped lang="css">
  #navbar .router-link-exact-active {
    @apply tw-bg-[#d7dbeb];
  }

  #navbar .active {
    @apply tw-bg-[#d7dbeb];
  }
</style>
